module.exports = __webpack_public_path__ + "static/def4_bleu-de7b170343601280935c2cd62512a6c1.jpg";